import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle, XCircle } from "lucide-react";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const email = params.get("email");
  const [status, setStatus] = useState("pending");

  useEffect(() => {
    if (!email) { setStatus("missing"); return; }
    api.get("/api/unsubscribe", { params: { email } })
      .then(({ data }) => setStatus(data.unsubscribed ? "done" : "notfound"))
      .catch(() => setStatus("error"));
  }, [email]);

  return (
    <div className="max-w-xl mx-auto px-6 py-24 text-center" data-testid="unsubscribe-page">
      {status === "done" && (
        <>
          <CheckCircle className="w-12 h-12 mx-auto text-[#064E3B]" />
          <h1 className="font-display font-black text-3xl mt-4">You're unsubscribed.</h1>
          <p className="text-[#4B5563] mt-2">{email} won't receive weekly digest emails. Important emails (payment, certificate) still come through.</p>
        </>
      )}
      {status === "pending" && <div className="text-[#4B5563]">Updating your preferences…</div>}
      {(status === "missing" || status === "notfound" || status === "error") && (
        <>
          <XCircle className="w-12 h-12 mx-auto text-[#D92D20]" />
          <h1 className="font-display font-black text-3xl mt-4">We couldn't find that email.</h1>
          <p className="text-[#4B5563] mt-2">Please contact support if you keep receiving emails.</p>
        </>
      )}
      <Link to="/" className="btn-outline inline-block mt-6" data-testid="unsub-home">Back home</Link>
    </div>
  );
}
